// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{box-sizing:border-box}.container_kib1i{position:relative;width:100%}", ""]);
// Exports
exports.locals = {
	"container": "container_kib1i"
};
module.exports = exports;
